<template>
    <div>
        <h5>Company Attributes</h5>
        <hr />
        <div class="p-menu" :style="{ width: '100%' }">
            <ul class="p-menu-list p-reset">
                <Accordion :multiple="true" :activeIndex="0">
                    <AccordionTab v-for="category in Object.keys(categorizedAttributes)" :key="category" :header="category">
                        <li class="p-menuitem" v-for="item in categorizedAttributes[category]" :key="item">
                            <div :draggable="true" @dragstart="dragStart(item)">
                                <FormAttribute :item="item" />
                            </div>
                        </li>
                    </AccordionTab>
                </Accordion>
            </ul>
        </div>
    </div>
</template>

<script setup>
import FormAttribute from './FormAttribute.vue';
import { useAttributeStore } from '../../../products/pha/modules/attribute/store';
import { useCategoryStore } from '../../../products/pha/modules/category/store';
import { storeToRefs } from 'pinia';
import { computed, onMounted, defineProps, defineEmits, watch } from 'vue';

const emit = defineEmits(['dragged-item']);
const props = defineProps({
    shared: {
        type: String,
    },
});
const attributeStore = useAttributeStore();
const categoryStore = useCategoryStore();

const { params, allAttributes } = storeToRefs(attributeStore);
const { flattendCategories } = storeToRefs(categoryStore);

const sharedType = computed(() => {
    return props.shared;
});

onMounted(async () => {
    // console.log(props.shared);
    params.value.shared = props.shared;
    await loadServices();
});

watch(sharedType, () => {
    // console.log('Shared type changed', sharedType.value);
    params.value.shared = sharedType.value;
    loadServices();
});

const loadServices = async () => {
    await loadAttributes();
    await loadCategories();
};

const loadAttributes = async () => {
    await attributeStore.fetchAllAttributes();
};

const loadCategories = async () => {
    await categoryStore.fetchCategories();
};
const dragStart = (item) => {
    emit('dragged-item', item);
};

const categorizedAttributes = computed(() => {
    let dataObj = {};
    // put all the attributes with no categories into a general category
    dataObj['General'] = allAttributes.value?.filter((attribute) => !attribute.category_id);
    // then store the remaining attributes on the basis of categories
    flattendCategories.value?.forEach((category) => {
        const attributes = allAttributes.value?.filter((attribute) => attribute.category_id == category.id);
        if (attributes && attributes.length) {
            dataObj[category.name] = attributes;
        }
    });
    return dataObj;
});
</script>

<style scoped>
.p-menu {
    border: none;
}
.p-menu {
    height: 70vh;
    overflow-y: auto;
}
</style>
